import authentication from './authentication';
import alarms from './alarms';
import aliaschannels from './aliaschannels';
import applications from './applications';
import claims from './claims';
import data from './data';
import domains from './domains';
import drivers from './drivers';
import emailtemplates from './emailtemplates';
import filesprivate from './filesprivate';
import filespublic from './filespublic';
import folders from './folders';
import globalnodetypetemplates from './globalnodetypetemplates';
import icons from './icons';
import lambdas from './lambdas';
import login from './login';
import logout from './logout';
import nodes from './nodes';
import nodetypes from './nodetypes';
import nodetypetemplates from './nodetypetemplates';
import notificationschemas from './notificationschemas';
import passwords from './passwords';
import permissions from './permissions';
import publish from './publish';
import reactions from './reactions';
import refresh from './refresh';
import reporting from './reporting';
import roles from './roles';
import rules from './rules';
import sessions from './sessions';
import tenant from './tenant';
import users from './users';
import usersubscriptions from './usersubscriptions';

export default {
  authentication,
  alarms,
  aliaschannels,
  applications,
  claims,
  data,
  domains,
  drivers,
  emailtemplates,
  filesprivate,
  filespublic,
  folders,
  globalnodetypetemplates,
  icons,
  lambdas,
  login,
  logout,
  nodes,
  nodetypes,
  nodetypetemplates,
  notificationschemas,
  passwords,
  permissions,
  publish,
  reactions,
  refresh,
  reporting,
  roles,
  rules,
  sessions,
  tenant,
  users,
  usersubscriptions,
};
